import Vue, { VueConstructor } from 'vue';
import moment from 'moment';
import i18n from './i18n';

moment.locale(i18n.locale);

const Moment = {
    install: (Vue: VueConstructor) => {
        Object.defineProperties(Vue.prototype, {
            $moment: {
                get() {
                    moment.locale(i18n.locale);
                    return moment;
                }
            }
        });
    }
}

Vue.use(Moment);